import { useTranslation } from 'react-i18next'
import { Chip } from '@mui/material'

import { OfflineConsultation } from '@/core/offline'
import { CellProps } from 'react-table'

export function SyncStatusCell({ value }: CellProps<OfflineConsultation, OfflineConsultation['_syncStatus']>) {
  const { t } = useTranslation()

  return (
    <Chip
      color={value === 'synced' ? 'success' : 'warning'}
      label={value === 'synced' ? t('sync.consultations.table.synced') : t('sync.consultations.table.pending')}
      size="small"
      variant="outlined"
    />
  )
}
